import script from "./EzCell.vue?vue&type=script&lang=ts&setup=true"
export * from "./EzCell.vue?vue&type=script&lang=ts&setup=true"

import "./EzCell.vue?vue&type=style&index=0&id=3d77d669&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d77d669"]])

export default __exports__